"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } /* eslint-disable default-param-last */
function ClientPushStream() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var error = arguments.length > 1 ? arguments[1] : undefined;
  this.url = options.url;
}
ClientPushStream.prototype.write = function write(rec) {
  var _window;
  if (!rec) {
    return;
  }
  var record = rec;
  if (_typeof(rec) === 'object') {
    if (Object.keys(rec).length === 0) {
      return;
    }
    record = JSON.stringify(record);
  }
  var _csrf = (_window = window) === null || _window === void 0 || (_window = _window.__INITIAL_STATE__) === null || _window === void 0 || (_window = _window.nuiPage) === null || _window === void 0 ? void 0 : _window._csrf;
  try {
    if (_csrf) {
      (0, _isomorphicFetch.default)(this.url, {
        credentials: 'same-origin',
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-csrf-token': _csrf
        },
        body: record
      });
    } else {
      (0, _isomorphicFetch.default)("".concat(this.url, "?body=").concat(encodeURIComponent(record)), {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });
    }
  } catch (e) {}
};
var _default = exports.default = ClientPushStream;